import React, { useLayoutEffect, useCallback } from "react";
import RUG from "react-upload-gallery";
import { getToken } from "infra/http";
import { useState } from "react";
import { Box } from "@chakra-ui/react";

interface CustomRUGProps {
  id: number;
  actionUrl: string;
  onDeleted: (i: any) => any;
  initialState: any;
  setCustomTriggerRefCallback?: (v: () => any) => any;
  extraHeaders?: Record<string, string>;
}

function CustomRUG({
  id,
  actionUrl,
  onDeleted,
  initialState,
  setCustomTriggerRefCallback,
  extraHeaders,
  ...rest
}: CustomRUGProps & Record<string, any>) {
  const [accessToken, setAccessToken] = useState<string | null>(null);

  const onCustomTriggerClick = useCallback(() => {
    const wrapper = document.getElementById(`custom-rug-wrapper-${id}`);

    const input = wrapper?.getElementsByClassName("rug-file-input");

    if (input && input.length) {
      (input[0] as any).click();
    }
  }, [id]);

  const onWarning = (type: any, rules: any) => {
    switch (type) {
      case "accept":
        console.log(`Only ${rules.accept.join(", ")}`);
        break;

      case "limit":
        console.log("limit <= ", rules.limit);
        break;

      case "size":
        console.log("max size <= ", rules.size);
        break;

      case "minWidth":
      case "minHeight":
        console.log("Dimensions > ", `${rules.width.min}x${rules.height.min}`);
        break;

      case "maxWidth":
      case "maxHeight":
        console.log("Dimensions < ", `${rules.width.max}x${rules.height.max}`);
        break;
    }
  };

  useLayoutEffect(() => {
    (async () => {
      const result = await getToken();

      setAccessToken(result);
    })();
  }, []);

  useLayoutEffect(() => {
    if (setCustomTriggerRefCallback && onCustomTriggerClick) {
      console.log("setCustomTrigger", setCustomTriggerRefCallback);
      setCustomTriggerRefCallback(onCustomTriggerClick);
    }
  }, [onCustomTriggerClick, setCustomTriggerRefCallback]);

  useLayoutEffect(() => {
    const wrapper = document.getElementById(`custom-rug-wrapper-${id}`);

    const originalTrigger =
      wrapper?.getElementsByClassName("rug-handle-button");

    if (originalTrigger && originalTrigger.length) {
      originalTrigger[0].innerHTML = "Selecione imagens para upload";
    }

    const orSpanWrapper = wrapper?.getElementsByClassName("rug-handle-info");

    const orSpan = orSpanWrapper?.[0]?.getElementsByTagName("span");

    if (orSpan && orSpan.length) {
      orSpan[0].innerHTML = "OU";
    }
  }, [id]);

  return (
    <>
      <Box
        w="100%"
        h="100%"
        id={`custom-rug-wrapper-${id}`}
        className={setCustomTriggerRefCallback ? "hide-rug-handle" : undefined}
      >
        <RUG
          onDeleted={onDeleted}
          initialState={initialState}
          action={actionUrl}
          rules={{
            limit: 15,
            size: 2000,
            // width: {
            //   min: 1280,
            //   max: 1920,
            // },
            // height: {
            //   min: 180,
            //   max: 180,
            // },
          }}
          accept={["jpg", "jpeg", "png"]}
          onWarning={onWarning}
          headers={{
            authorization: `Bearer ${accessToken}`,
            ...extraHeaders,
          }}
          source={(response: { url: string }) => response.url}
          {...rest}
        />
      </Box>
    </>
  );
}

export default CustomRUG;
